import BasicInfoForm from './basicInfoForm.container'

export default BasicInfoForm